// инжектит в приложение и компоненты функцию $absoluteImageUrl для построения абсолютного url
export default ({ app, $config }, inject) => {
  inject('absoluteImageUrl', url => {
    if (url) {
      if (typeof url === 'string') {
        if(/^http/.test(url)) {
          return url
        }
        return `${$config.backendUrl}${url}`
      } else if (Array.isArray(url)) {
        return url.map(u => `${$config.backendUrl}${u}`)
      }
    }

    return url
  })
}
